import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { useNotification } from '../../../../hooks'
import { isSamePage } from '../../../../utils/common'
import { getNotificationViewTableRedirectPath } from '../../../../utils/link'
import { setStorageCombiningPhaseAsyncStatus } from '../../DocFlow.utils.storage'
import { useDocFlowContext } from '../useDocFlowContext'

import {
  checkTaskStatus,
  isAsyncTaskSuccess,
} from './useLoadCombiningPhaseAsync.utils'

export function useLoadCombiningPhaseAsync(props) {
  const { asyncTask } = props

  const { handleReloadDocFlow } = useDocFlowContext()

  const { t } = useTranslation()

  const location = useLocation()

  const {
    handleAddErrorNotification,
    handleAddInfoNotification,
    handleAddSuccessNotification,
  } = useNotification()

  function handleAddFinishAsyncCombiningPhaseNotification(data) {
    const notificationHandler = isAsyncTaskSuccess(data)
      ? handleAddSuccessNotification
      : handleAddErrorNotification

    notificationHandler({
      ...(isSamePage(location.pathname)
        ? null
        : {
            linkProps: {
              title: t('Notification.CommonAsyncActionFinishedOpenResultKey'),
              to: getNotificationViewTableRedirectPath(location.pathname),
            },
            text: t('DocumentStapling.StartCombiningPhaseAsyncReadyTextKey'),
          }),
      title: t('DocumentStapling.StartCombiningPhaseAsyncReadyTitleKey'),
    })

    setStorageCombiningPhaseAsyncStatus(false)

    if (isSamePage(location.pathname)) {
      props.onLoadInit()
    }
  }

  function handleAsyncCombiningPhase() {
    setStorageCombiningPhaseAsyncStatus(true)

    handleAddInfoNotification({
      text: t('Notification.CommonAsyncMassActionStartedKey'),
      title: t('Notification.DocumentStaplingStartCombiningPhaseAsyncTitleKey'),
    })

    checkTaskStatus({
      task: asyncTask,
      onReadyTask: handleAddFinishAsyncCombiningPhaseNotification,
      onReloadProfile: handleReloadDocFlow,
    })
  }

  useEffect(() => {
    if (asyncTask) {
      handleAsyncCombiningPhase()
    } else {
      props.onLoadInit()
    }
  }, [])
}
